import { mapGetters, mapActions } from 'vuex'
import { every, isUndefined, truncate } from 'lodash'
import globaltypes from '../../store/globaltypes'

export default {
  name: 'productinfo',
  props: [
    'productID',
    'action'
  ],
  mounted () {
    if (this.productID === undefined) return
    if (this.product && this.product.varieties && this.product.varieties.length > 0) this.variationID = this.product.varieties[0].ID
  },
  data () {
    return {
      showInfo: false,
      variationID: 0,
      isDescriptionExpanded: false
    }
  },
  methods: {
    ...mapActions({
      setInformation: globaltypes.main.actions.setInformation
    }),
    showEvenMoreInfo () {
      var win = window.open(this.product.url, '_blank')
      win.focus()
    },
    clickHeart () {
      if (!this.isInStock) {
        this.setInformation(this.$t('wishlist.out_of_stock'))
        return
      }
      if (this.isVariable) this.showInfo = true
      else this.action(this.productID, this.variationID)
    },
    expandDescription () {
      this.isDescriptionExpanded = true
    }
  },
  computed: {
    ...mapGetters({
      getProduct: globaltypes.products.getters.product
    }),
    isInStock () {
      if (isUndefined(this.product.stockQuantity)) {
        return !every(this.product.varieties, variation => (variation.stockQuantity || '0') <= 0)
      }
      return parseFloat(this.product.stockQuantity || '0') > 0
    },
    isSelectedVariationInStock () {
      if (!this.product.variaties) return this.isInStock
      const variation = this.product.varieties.find(variation => variation.ID === this.variationID)
      if (!variation) return false
      return (variation.stockQuantity || '0') > 0
    },
    product () {
      return this.getProduct(this.productID)
    },
    truncatedDescription () {
      return truncate(this.product.description, { length: 80, separator: ' ', omission: '&#x2026;' })
    },
    price () {
      var price = (this.product.price || 0)
      if (this.variationID) {
        price = this.product && this.product.varieties && this.product.varieties.filter(x => x.ID === this.variationID)[0] ? ((this.product.varieties.filter(x => x.ID === this.variationID)[0]).price || 0) : 0
      }
      return price
    },
    isVariable () {
      return this.getProduct(this.productID).varieties && this.getProduct(this.productID).varieties
    }
  },

  watch: {
    product (val) {
      if (val && val.varieties && val.varieties.length > 0) this.variationID = val.varieties[0].ID
    }
  }
}
